class SpeakAndWrite {
    recognition = null;
    selectedDom = null;
    start = false;
    constructor() {
        window.SpeechRecognition = window.SpeechRecognition
            || window.webkitSpeechRecognition;

        this.recognition = new SpeechRecognition();
        //this.recognition.interimResults = true;
    }

    deRegisterEvent(){
        this.recognition.removeEventListener("result", this.resultEvent);
        this.recognition.removeEventListener("end", this.recognition.start);
        this.selectedDom = null;
    }

    registerEvent(){
        this.recognition.addEventListener('result', e => { this.resultEvent(e) });
        this.recognition.start();
        //this.recognition.addEventListener('end', this.recognition.start);
    }

    resultEvent(e){
        const transcript = Array.from(e.results)
            .map(result => result[0])
            .map(result => result.transcript)
            .join('')

        this.applyText(transcript);
    }

    applyText(text){
        if(this.selectedDom){
            if (this.isTextInput(this.selectedDom) ){
                this.selectedDom.value = (this.selectedDom.type=="number" || this.selectedDom.classList.contains("nosapce"))?text.replace(/\s+|\s+/gm,""):text;
            } else {
                this.selectedDom.innerHTML = text;
            }
        }
    }

    isTextInput(ele){
        let tagName = ele.tagName;
        if(tagName === "INPUT"){
            let validType = ['number', 'text', 'password', 'email', 'tel', 'url', 'search', 'date', 'datetime', 'datetime-local', 'time', 'month', 'week'];
            let eleType = ele.type;
            return validType.includes(eleType);
        }

        return false;
    }
}
/*
document.onclick = function (event) {
    try {
        if (window.SpeakAndWrite.selectedDom && event.target.classList.contains("speechtotextOn")) {
            window.SpeakAndWrite.registerEvent();
            return;
        } else if (event.target.classList.contains("speechtotext")) {
            window.SpeakAndWrite.selectedDom = event.target;
            return;
        }
        window.SpeakAndWrite.deRegisterEvent();
    } catch (e) {
        console.log(e);
        //window.SpeakAndWrite.deRegisterEvent();
    }
}

window.SpeakAndWrite = new SpeakAndWrite();
*/